<template>
	<div>
		<div class="columns">
			<div class="column is-4">
				<nav class="breadcrumb has-succeeds-separator has-text-weight-bold" aria-label="breadcrumbs">
					<ul>
						<li class="is-active"><a rel="noreferrer" href="#" aria-current="page">{{ sitelocale == 'en' ? 'News' : 'الأنشطة والأخبار'}}</a></li>
					</ul>
				</nav>
			</div>
			<div class="column is-5">
			</div>
			<!--<div class="column is-3">
				<div class="control is-expanded has-text-left">
					<div class="select is-rounded is-primary is-size-6">
						<select>
							<option disabled selected>ترتيب حسب</option>
							<option>With options</option>
						</select>
					</div>
				</div>
			</div>-->
		</div>
		<div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="8">
			<div class="columns is-multiline mt40">
				<div class="column is-6 hvr-grow p20"  v-for="post in items">
					<div class="card has-background-white overflow-hidden">
						<div class="columns is-gapless">
							<div class="column is-5">
								<a rel="noreferrer" :href="`/${sitelocale}/posts/${post.id}`">
									<figure class="image image-cover height-260">
										<lazy-load
										src="/front/img/spinner.svg"
										lazy-src="/front/img/img.png"
										:lazy-srcset="post.image"
										background-color="transparent"
										:alt="post.title"
										/>
									</figure>
								</a>
							</div>
							<div class="column is-7">
								<div class="display-table w-100 height-full is-block has-text-centered has-text-weight-bold has-text-primary p5">
									<div class="display-table-cell vertical-align has-text-right px10">
										<p class="height-114 overflow-hidden">{{ post.title }}</p>
										<p class="has-text-grey mt10">{{ post.date }}</p>
										<a rel="noreferrer" class="button btn-warning hvr-shutter-out-vertical hvr-primary is-rounded pr30 pl30 mt20" :href="`/${sitelocale}/posts/${post.id}`">
                                            {{ sitelocale == 'en' ? 'Read more' : 'اقرأ المزيد'}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
			<div class="has-text-centered"  v-show="loadMore">
				<a rel="noreferrer" class="button is-primary hvr-shutter-out-vertical hvr-warning is-rounded p25 pr40 pl40" href="">{{ sitelocale == 'en' ? 'Load more' : 'تحميل المزيد'}}</a>
			</div>
		</div>
	</template>
	<script>
	import axios from 'axios';
	import infiniteScroll from 'vue-infinite-scroll';
	import LazyLoad from '../GeneralComponents/LazyLoad';
export default {
	name: 'sub-categories',
	components: {
		LazyLoad ,
	},
	directives: {
		infiniteScroll
	},
	props: {
		data: {
			type: Array,
			default: () => []
		},
		url: String,
        sitelocale:{
			type:String,
			required: true
		}
	},
	computed: {
		busy() {
			return this.fetching
		}
	},
	mounted() {
	},
	data: () => ({
		items: [],
		order : [],
		currentPage: 0,
		fetching: false,
		nextUrl : String,
		loadMore : true,
		isActive: false
	}),
	methods: {
        loadNextPage() {
            this.currentPage++;
            this.fetching = true;
            if(this.nextUrl != null){
                axios.get(this.nextUrl).then(({ data }) => {
                    this.items.push(...data.data);
                    if(data.links.next != null) {
                        this.nextUrl = data.links.next;
                    } else {
                        this.nextUrl = data.links.next;
                    }
                    this.fetching = false;
                });
            }
            else{
                this.loadMore = false;
            }
        }
	},
	created() {
		this.nextUrl = this.url;
		this.items = [];
		this.loadNextPage();
	}
};
</script>
